import React from 'react';
import { ConfigProvider, App as AntdApp } from 'antd';
import 'react-input-range/lib/css/index.css';
import 'react-perfect-scrollbar/dist/css/styles.css';
import 'react-toastify/dist/ReactToastify.css';
import 'slick-carousel/slick/slick-theme.css';
import 'slick-carousel/slick/slick.css';
import 'react-responsive-modal/styles.css';
// Swiper Slider
import 'swiper/css';
import 'swiper/css/navigation';

import './assets/css/antd-v4-compat.css';
import './assets/css/main.css';
import './assets/css/home-brand.css';

import { ToastContainer, Bounce } from 'react-toastify';
import Router from './navigation/routes';
import BeforeAppLoad from 'components/layout/BeforeAppLoad';
import { antdV4CompatTheme } from 'theme/antdTheme';

const App = () => (
  <ConfigProvider theme={antdV4CompatTheme} wave={{ disabled: true }}>
    <AntdApp>
      <BeforeAppLoad>
        <Router />
        <ToastContainer
          autoClose={2000}
          position="top-right"
          transition={Bounce}
          rtl={false}
          hideProgressBar={false}
          closeButton
          pauseOnHover
          pauseOnFocusLoss
          closeOnClick
          newestOnTop={false}
          draggable
          draggablePercent={80}
          draggableDirection="x"
          role="alert"
          theme="light"
        />
      </BeforeAppLoad>
    </AntdApp>
  </ConfigProvider>
);

export default App;
// https://zapkart-firebase.netlify.app
